import React from 'react';
import { Route, Switch } from 'react-router-dom/cjs/react-router-dom.min';
import OutboxSearch from './outboxSearch';
import ViewMail from './viewMail';

const OutboxRouter = () => (
  <Switch>
    <Route exact path="/outbox" component={OutboxSearch} />
    <Route exact path="/outbox/:id" component={ViewMail} />
  </Switch>
);

export default OutboxRouter;
